const TokenKey = 'Admin-Token'

export function getToken (key) {
  if (key) {
    return JSON.parse(localStorage.getItem(key))
  } else {
    return localStorage.getItem(TokenKey)
  }
}

export function setToken (value, key) {
  if (key) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    localStorage.setItem(TokenKey, value)
  }
}

export function removeToken () {
  localStorage.removeItem(TokenKey)
  localStorage.removeItem('shopInfo')
  localStorage.removeItem('userInfo')

}



// WEBPACK FOOTER //
// ./src/utils/auth.js